import { Contract } from '../../customProvider/objects/contract';
import { CustomProvider } from '../../customProvider/objects/customProvider';
import { DestinationReduced } from '../../destination/objects/destinationReduced';
import { Locale } from '../../locale/objects/locale';
import { MarketView } from '../../marketView/objects/marketView';
import { Owner } from '../../organisation/objects/owner';
import { Picture } from '../../picture/objects/picture';
import { Place } from '../../place/objects/place';
import { Provider } from '../../provider/objects/provider';
import { Author } from '../../user/objects/author';
import { ClosedDay } from './closedDay';
import { Holiday } from './holiday';
import { ManualActivityContact } from './manualActivityContact';
import { ManualActivityLocalized } from './manualActivityLocalized';
import { ManualActivityVariant, ProductMarketType } from './manualActivityVariant';
import { OpenDays } from './openDays';
import { OriginalProduct } from './originalProduct';

export enum BookingEngine {
    "CIRCUIT" = "CIRCUIT",
    "TAILOR_MADE" = "TAILOR_MADE",
    "ACTIVITY" = "ACTIVITY"
}

export enum ActivityType {
    ACTIVITY = "ACTIVITY",
    TRANSFER = "TRANSFER",
    TRAIN = "TRAIN",
    FERRY = "FERRY",
    SERVICE = "SERVICE",
    GUIDE = "GUIDE",
    MEAL = "MEAL",
    RESTAURANT = "RESTAURANT",
    FLIGHTS = "FLIGHTS",
    CAR_RENTAL = "CAR_RENTAL",
    GUIDE_DRIVER = "GUIDE_DRIVER",
    EQUIPMENT = "EQUIPMENT"
  }

export const MANUAL_ACTIVITY_TYPE: Record<ActivityType, number> = {
    ACTIVITY: 12,
    TRANSFER: 4,
    TRAIN: 5,
    FERRY: 13,
    MEAL: 18,
    FLIGHTS: 6,

    GUIDE: 10,
    CAR_RENTAL: 2,

    // TODO : check real content type
    RESTAURANT: 12,
    GUIDE_DRIVER: 12,
    EQUIPMENT: 12,
    SERVICE: 12,
};


export interface ManualActivity {
    provider: Provider | null;
    providers: CustomProvider[];
    provider_lib: null | string;
    provider_ref: null | string;
    fake_hotel_code: null | string;
    destination: null | DestinationReduced;
    visibility: 'PUBLIC' | 'PRIVATE_TO' | 'PRIVATE';
    created_date: Date | null;
    creator: null | Author;
    modified_date: Date | null;
    last_author: Author | null;
    contracts: Contract[] | null;
    deactivated_contracts: number[];
    picture?: any;
    multiple_days: boolean;
    special_attribute: null | 'TRANSPORT_PASS' | 'GUIDE';
    poi_type: boolean;
    is_pepite: boolean;
    selected_holidays: Holiday[]
    closed_days: ClosedDay[];
    audio_guide: boolean;
    cover_picture: null | Picture;
    cut_line: null | boolean;
    description_lang: null | Locale;
    duration: number;
    email: null | string;
    for_children: boolean;
    for_disabled: boolean;
    good_to_know: null | string;
    guide: boolean;
    guide_lang: null | string[];
    id: number;
    included: null | string[];
    is_custom: boolean;
    localization: ManualActivityLocalized[];
    long_description: null | string;
    max_pax: null | number;
    need_pax_weight: boolean;
    not_included: null | string[];
    og_updated: boolean;
    original_product: null | OriginalProduct;
    owner: Owner;
    phone_number: string;
    pictures: Picture[];
    place: null | Place;
    product_code: string;
    product_number_model: boolean;
    product_type: number;
    rating: null | number;
    recommended: boolean;
    hide_localization: boolean;
    short_description: null | string;
    supplier_address: null | string;
    supplier_city_name: null | string;
    provider_name: null | string;
    supplier_phone: null | string;
    supplier_zip_code: null | string;
    title: null | string;
    voucher_text: null | string;
    website: string;
    schedules: OpenDays[];
    variants: ManualActivityVariant[];
    linked_products: ManualActivity[];
    contacts: ManualActivityContact[];
    hotel_required: boolean;
    voucher_manual: boolean;
    label_eco: boolean;

    type: ActivityType;

    lock: boolean;
    hide_hours: boolean;
    publish_on_web: boolean;

    search_engines: BookingEngine[];

    allowed_markets: MarketView[],
    market_type: ProductMarketType,
    sub_market: MarketView | null,
    exception_cms?: { id: number, name: string }[],
}